"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var currencySlice_1 = require("../../features/currencies/currencySlice");
var Logo_1 = __importDefault(require("../Logo/Logo"));
var Dropdown_1 = __importDefault(require("../Dropdown"));
var Routes_1 = require("../../constants/Routes");
var react_i18next_1 = require("react-i18next");
var useActionForbidden_1 = require("../../hooks/useActionForbidden");
var react_router_dom_1 = require("react-router-dom");
var GeneralSettings_1 = require("../../constants/GeneralSettings");
var loginSlice_1 = require("../../features/login/loginSlice");
var close_svg_1 = __importDefault(require("../../../images/close.svg"));
var Localization_1 = require("../../constants/Localization");
var i18n_1 = __importDefault(require("../../i18n"));
var auth_1 = require("../../helpers/auth");
var LanguageList_1 = __importDefault(require("./LanguageList"));
var AccountDropDown_1 = __importDefault(require("./AccountDropDown"));
var MobileMenu = function (_a) {
    var open = _a.open, mobileOpen = _a.mobileOpen;
    var history = react_router_dom_1.useHistory();
    var dispatch = react_redux_1.useDispatch();
    var currencyList = react_redux_1.useSelector(currencySlice_1.selectCurrencies);
    var currentCurrency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var t = react_i18next_1.useTranslation('common').t;
    var currencyChangeHandler = function (value) {
        dispatch(currencySlice_1.setCurrency(value));
    };
    var handleLinkClick = function (event, path) {
        event.preventDefault();
        history.push(path);
        mobileOpen();
        dispatch(loginSlice_1.closeLoginFormModal());
    };
    var openAnnouncement = useActionForbidden_1.useActionForbidden(function () {
        history.push(Routes_1.Routes.Announcement.path);
    });
    var handleOpenAnnouncement = function () {
        mobileOpen();
        openAnnouncement();
    };
    var handleOpenLoginForm = react_1.useCallback(function () {
        mobileOpen();
        dispatch(loginSlice_1.openLoginFormModal({
            redirectAfterLogin: true,
        }));
    }, [mobileOpen]);
    return (react_1.default.createElement("div", { className: !open ? 'mobile-menu' : "mobile-menu mobile-menu--open" },
        react_1.default.createElement("div", { className: "mobile-menu__backdrop", onClick: mobileOpen }),
        react_1.default.createElement("div", { className: "mobile-menu__body" },
            react_1.default.createElement("div", { className: "mobile-menu__content" },
                react_1.default.createElement("div", { className: "mobile-menu__content__head" },
                    react_1.default.createElement("div", { className: "mobile-menu__header", onClick: mobileOpen },
                        react_1.default.createElement(Logo_1.default, null),
                        react_1.default.createElement("img", { src: close_svg_1.default, alt: "close" })),
                    react_1.default.createElement("div", { className: "action_content" },
                        react_1.default.createElement("a", { className: "btn btn-primary open-announcement", href: "#", onClick: handleOpenAnnouncement }, t('HEADER.Button')),
                        react_1.default.createElement("ul", null,
                            react_1.default.createElement("li", null,
                                react_1.default.createElement(react_router_dom_1.Link, { to: '', onClick: function (event) {
                                        return handleLinkClick(event, "/" + (Localization_1.SellPagePrefix[i18n_1.default.language].sell + '?state=1'));
                                    } },
                                    t('HEADER.Menu.Buy'),
                                    ' ')),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement(react_router_dom_1.Link, { to: '', onClick: function (event) {
                                        return handleLinkClick(event, "/" + (Localization_1.SellPagePrefix[i18n_1.default.language].rent + '?state=1'));
                                    } },
                                    t('HEADER.Menu.Rent'),
                                    ' ')),
                            react_1.default.createElement("li", null)))),
                react_1.default.createElement("div", { className: "mobile-menu__content__foot" },
                    react_1.default.createElement("div", { className: "action_content" },
                        !auth_1.isAuthenticated() ? (react_1.default.createElement("button", { className: "btn btn-primary login", onClick: handleOpenLoginForm }, t('login.SIGN_IN'))) : (react_1.default.createElement(AccountDropDown_1.default, { closeMobileMenu: mobileOpen })),
                        react_1.default.createElement(LanguageList_1.default, null),
                        react_1.default.createElement(Dropdown_1.default, { onChange: currencyChangeHandler, itemKey: "code", itemValue: "original", list: currencyList, selected: currentCurrency, hasCustomIcon: true, itemTemplate: function (elem, idx) {
                                return (react_1.default.createElement("span", { key: idx },
                                    elem.curSymbol,
                                    " ",
                                    elem.original));
                            } })),
                    react_1.default.createElement("a", { className: "mobile-menu-contacts", href: "tel:" + GeneralSettings_1.GENERAL_SETTINGS.CONTACT_PHONE.PHONE_NUMBER },
                        react_1.default.createElement("i", { className: "cm-icon icon-phone" }),
                        t('call_now'),
                        " \u00A0",
                        GeneralSettings_1.GENERAL_SETTINGS.CONTACT_PHONE.FORMATED))))));
};
exports.default = MobileMenu;
